<!--  -->
<template>
  <div
    id=""
    style="width:100%; height:100%;position: relative;"
    class="t-hover-shadow"
  >
    <img @click="jumpTypeList()" id="typeimg" :src="url" />
    <div id="typeTitle">
      <el-button size="small" round @click="jumpTypeList()" plain>{{
        title
      }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    typeName: String,
    title: String,
    url: String
  },
  data () {
    return {
      iurl: ''
    }
  },
  methods: {
    jumpTypeList () {
      this.$store.commit('setGlobalObjOfSearchType', this.title + '编')
      this.$store.commit('setGlobalObjOfSearchKeyWords', '')
      this.$router.push('/imgList/barrel').catch(() => {})
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
#typeimg {
  width: 100%;
  height: 100%;
  border-radius: 2px 2px 2px 2px;
  cursor: pointer;
}

#typeTitle {
  color: rgb(0, 0, 0);
  font-size: 25px;
  height: 30px;
  text-align: right;
  width: auto;
  position: absolute;
  top: 30px;
  right: 50px;
  cursor: pointer;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white; /**给分类的字体加白边 */
}

.t-hover-shadow {
  transition: transform 0.3s ease-in-out,
    box-shadow 0.3s cubic-bezier(0.47, 0, 0.745, 0.715), border 0.3s linear 0.1s;
}

.t-hover-shadow:hover {
  /**鼠标滑过特效 */
  box-shadow: 0 10px 50px rgba(51, 51, 51, 0.25);
  -webkit-transform: translateY(-10px);
  -moz-transform: translateY(-10px);
  transform: translateY(-10px);
}
</style>
